import React from 'react';

const DraggableOverlay = ({ field }) => (
  <div className="cursor-pointer p-2 border rounded mb-2 bg-gray-100">
    {field}
  </div>
);

export default DraggableOverlay;
